function initSwiper(slider) {
  const sliderOptions = {
    slidesPerView: "auto",
    spaceBetween: 10,
    navigation: {
      nextEl: slider.querySelector('[data-swiper-button-next]'),
      prevEl: slider.querySelector('[data-swiper-button-prev]'),
    },
    breakpoints: {
      280: {
        slidesPerView: 4.5,
      },
      360: {
        slidesPerView: 4.5,
      },
      420: {
        slidesPerView: 5.5,
      },
      480: {
        slidesPerView: 4.5,
      },
      769: {
        slidesPerView: 4.5,
      }
    }
  };
  new Swiper(slider, sliderOptions);
}

document.querySelectorAll('[data-swatches-slider]').forEach(slider => {
  initSwiper(slider);
});
